import { useEffect, useState } from 'react';
import { Badge, Box, IconButton, Tooltip, Zoom } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../../app/redux/hooks';
import { Icon } from '@iconify/react';
import yaantrac from '../../../../app/assets/images/logo.png';
import ayka from '../../../../app/assets/images/landing/AYKA.png';
import MyProfile from '../../../pages/user/settings/myprofile/MyProfile';
import Notifications from '../../../../features/yaantrac/pages/notifications/Notifications';
import './SideNavbar.scss';

function SideNavbar(): JSX.Element {
  const [selectedBadge, setSelectedBadge] = useState<number | null>();
  const [isOpen, setIsOpen] = useState<string>('');

  const navigate = useNavigate();
  const location = useLocation();

  const { theme } = useAppSelector(state => state.theme);
  const { data } = useAppSelector(state => state.auth);
  const { pathname } = location;

  const { data: roleAccess, category } = useAppSelector(state => state.RoleModuleAccess);
  const roleModules = roleAccess?.flatMap((item: any) =>
    item?.modules?.map((module: any) => module?.moduleName)
  );

  const roleModuleTypes = ['tour', 'regular', 'vehicle', 'pickup', 'driver'];

  let roletype = data?.role;

  const deliveryTracking = roletype === 'ROLE_DT_ADMIN';
  const APsuperAdmin = roletype === 'ROLE_AUTOPLANNER_ADMIN';
  const APoperator = roletype === 'ROLE_OPERATOR';
  const APagent = roletype === 'ROLE_AGENT';
  const APsubAgent = roletype === 'ROLE_SUB_AGENT';
  const logistics = roletype === 'ROLE_LOGISTICS_ADMIN';
  const yaanTRAC = roletype === 'ROLE_YAANTRAC_ADMIN';
  const toDisplay = [
    APagent,
    APsubAgent,
    deliveryTracking,
    APsuperAdmin,
    APoperator,
    logistics,
    category === 'OPERATION_USER'
  ];

  const handleBadgeClick = (badgeNumber: number): void => {
    setSelectedBadge(badgeNumber);
    if (badgeNumber === 1) {
      navigate('/dashboard');
    } else if (badgeNumber === 2) {
      navigate('/dashboard2');
    } else if (badgeNumber === 3) {
      navigate('/livetracking');
    } else if (badgeNumber === 4) {
      navigate('/historictracking');
    } else if (badgeNumber === 5) {
      navigate('/management');
    } else if (badgeNumber === 6) {
      navigate('/today-trips');
    } else if (badgeNumber === 12) {
      navigate('/deliverytracking');
    } else if (badgeNumber === 7) {
      navigate('/trips');
    } else if (badgeNumber === 8) {
      navigate('/configuration');
    } else if (badgeNumber === 10) {
      navigate('/dispatch');
    } else if (badgeNumber === 11) {
      navigate('/deliveryload');
    } else if (badgeNumber === 13) {
      navigate('/geofencemapping');
    } else if (badgeNumber === 14) {
      navigate('/configuration/agents');
    } else if (badgeNumber === 15) {
      navigate('/trips/autoplannertrips/tours');
    } else if (badgeNumber === 16) {
      navigate('/trips/autoplannertrips/scheduled-tour');
    } else if (badgeNumber === 19) {
      navigate('/users');
    } else if (badgeNumber === 18) {
      navigate('/deliveryorders');
    } else {
      navigate('/dispatch-management');
    }
  };

  const OpenMyProfile = () => {
    setIsOpen('myprofile');
  };

  // for open notification component
  const handleOpenNotification = () => {
    handleBadgeClick(9);
    navigate('/historynotifications');
  };

  const handleClose = () => setIsOpen('');

  useEffect(() => {
    if (pathname === '/dashboard') {
      setSelectedBadge(1);
    } else if (pathname === '/dashboard2') {
      setSelectedBadge(2);
    } else if (pathname === '/livetracking') {
      setSelectedBadge(3);
    } else if (pathname === '/historictracking') {
      setSelectedBadge(4);
    } else if (pathname.split('/')[1] === 'management') {
      setSelectedBadge(5);
    } else if (pathname === '/today-trips') {
      setSelectedBadge(6);
    } else if (
      pathname.split('/')[1] === 'trips' &&
      selectedBadge !== 15 &&
      selectedBadge !== 16
    ) {
      setSelectedBadge(7);
    } else if (pathname.split('/')[1] === 'configuration') {
      setSelectedBadge(8);
    } else if (pathname === '/historynotifications') {
      setSelectedBadge(9);
    } else if (pathname === '/dispatch') {
      setSelectedBadge(10);
    } else if (pathname === '/deliverytracking' || pathname === '/adddeliverytrip') {
      setSelectedBadge(12);
    } else if (pathname === '/geofencemapping') {
      setSelectedBadge(13);
    } else if (pathname === '/configuration/agents') {
      setSelectedBadge(14);
    } else if (pathname === '/trips/autoplannertrips/tours') {
      setSelectedBadge(15);
    } else if (pathname === '/trips/autoplannertrips/scheduled-tour') {
      setSelectedBadge(16);
    } else if (pathname.split('/')[1] === 'users') {
      setSelectedBadge(19);
    }
  }, [pathname]);

  useEffect(() => {
    localStorage.setItem('lastVisitedPage', pathname);
  }, [location]);

  return (
    <Box className='root'>
      <Box
        className='logo'
        p={1}
        onClick={() => {
          navigate('/dashboard');
          handleBadgeClick(1);
        }}
      >
        <Box component='img' src={theme === 'ayka' ? ayka : yaantrac} />
      </Box>
      <Box className='navbar d-flex-c'>
        <Box className='componentsIcons d-flex-c'>
          {!toDisplay?.some((item: boolean) => item) && (
            <>
              <Tooltip
                leaveDelay={100}
                title='Dashboard'
                placement='right'
                TransitionProps={{ timeout: 300 }}
                TransitionComponent={Zoom}
                arrow
              >
                <Badge
                  className={
                    selectedBadge === 1 || pathname === '/dashboard'
                      ? 'active'
                      : 'nonActive'
                  }
                  onClick={() => handleBadgeClick(1)}
                >
                  <Icon
                    className={
                      selectedBadge === 1 || pathname === '/dashboard'
                        ? 'activeIcon icon'
                        : 'icon'
                    }
                    icon='majesticons:analytics-line'
                  />
                </Badge>
              </Tooltip>
              <Tooltip
                leaveDelay={100}
                title='Live Tracking'
                placement='right'
                TransitionProps={{ timeout: 300 }}
                TransitionComponent={Zoom}
                arrow
              >
                <Badge
                  className={
                    selectedBadge === 3 || pathname === '/livetracking'
                      ? 'active'
                      : 'nonActive'
                  }
                  onClick={() => handleBadgeClick(3)}
                >
                  <Icon
                    className={
                      selectedBadge === 3 || pathname === '/livetracking'
                        ? 'activeIcon icon'
                        : 'icon'
                    }
                    icon='grommet-icons:map'
                  />
                </Badge>
              </Tooltip>
              <Tooltip
                leaveDelay={100}
                title='Historic Tracking'
                placement='right'
                TransitionProps={{ timeout: 300 }}
                TransitionComponent={Zoom}
                arrow
              >
                <Badge
                  className={
                    selectedBadge === 4 || pathname === '/historictracking'
                      ? 'active'
                      : 'nonActive'
                  }
                  onClick={() => handleBadgeClick(4)}
                >
                  <Icon
                    className={
                      selectedBadge === 4 || pathname === '/historictracking'
                        ? 'activeIcon icon'
                        : 'icon'
                    }
                    icon='tabler:flag-pin'
                  />
                </Badge>
              </Tooltip>
            </>
          )}

          {(APagent ||
            APsubAgent ||
            APsuperAdmin ||
            APoperator ||
            category === 'OPERATION_USER') && (
            <Tooltip
              leaveDelay={100}
              title='Live Dashboard'
              placement='right'
              TransitionProps={{ timeout: 300 }}
              TransitionComponent={Zoom}
              arrow
            >
              <Badge
                className={
                  selectedBadge === 6 || pathname === '/today-trips'
                    ? 'active'
                    : 'nonActive'
                }
                onClick={() => handleBadgeClick(6)}
              >
                <Icon
                  className={
                    selectedBadge === 6 || pathname === '/today-trips'
                      ? 'activeIcon icon'
                      : 'icon'
                  }
                  icon='material-symbols:today-rounded'
                />
              </Badge>
            </Tooltip>
          )}
          {deliveryTracking && (
            <>
              <Tooltip
                leaveDelay={100}
                title='Orders'
                placement='right'
                TransitionProps={{ timeout: 300 }}
                TransitionComponent={Zoom}
                arrow
              >
                <Badge
                  className={
                    selectedBadge === 18 || pathname === '/deliveryorders'
                      ? 'active'
                      : 'nonActive'
                  }
                  onClick={() => handleBadgeClick(18)}
                >
                  <Icon
                    className={
                      selectedBadge === 18 || pathname === '/deliveryorders'
                        ? 'activeIcon icon'
                        : 'icon'
                    }
                    icon='mdi:package-variant-closed'
                  />
                </Badge>
              </Tooltip>
              <Tooltip
                leaveDelay={100}
                title='Load'
                placement='right'
                TransitionProps={{ timeout: 300 }}
                TransitionComponent={Zoom}
                arrow
              >
                <Badge
                  className={
                    selectedBadge === 11 || pathname === '/deliveryload'
                      ? 'active'
                      : 'nonActive'
                  }
                  onClick={() => handleBadgeClick(11)}
                >
                  <Icon
                    className={
                      selectedBadge === 11 || pathname === '/deliveryload'
                        ? 'activeIcon icon'
                        : 'icon'
                    }
                    icon='streamline-plump:shipment-upload-remix'
                    width={18}
                    height={18}
                  />
                </Badge>
              </Tooltip>

              <Tooltip
                leaveDelay={100}
                title='Dispatch'
                placement='right'
                TransitionProps={{ timeout: 300 }}
                TransitionComponent={Zoom}
                arrow
              >
                <Badge
                  className={
                    selectedBadge === 10 || pathname === '/dispatch'
                      ? 'active'
                      : 'nonActive'
                  }
                  onClick={() => handleBadgeClick(10)}
                >
                  <Icon
                    className={
                      selectedBadge === 10 || pathname === '/dispatch'
                        ? 'activeIcon icon'
                        : 'icon'
                    }
                    icon='mynaui:truck'
                  />
                </Badge>
              </Tooltip>
            </>
          )}
          {!APagent && !APsubAgent ? (
            <Tooltip
              leaveDelay={100}
              title={
                APsubAgent || APagent || APoperator || APsuperAdmin ? 'Bookings' : 'Trips'
              }
              placement='right'
              TransitionProps={{ timeout: 300 }}
              TransitionComponent={Zoom}
              arrow
            >
              <Badge
                className={
                  selectedBadge === 7 || pathname === '/trips' ? 'active' : 'nonActive'
                }
                onClick={() => handleBadgeClick(7)}
              >
                <Icon
                  className={
                    selectedBadge === 7 || pathname === '/trips'
                      ? 'activeIcon icon'
                      : 'icon'
                  }
                  icon='bx:trip'
                />
              </Badge>
            </Tooltip>
          ) : (
            ''
          )}

          {(APagent || APsubAgent) && (
            <Tooltip
              leaveDelay={100}
              title='Bookings'
              placement='right'
              TransitionProps={{ timeout: 300 }}
              TransitionComponent={Zoom}
              arrow
            >
              <Badge
                className={
                  selectedBadge === 15 || pathname === '/trips/autoplannertrips/tours'
                    ? 'active'
                    : 'nonActive'
                }
                onClick={() => handleBadgeClick(15)}
              >
                <Icon
                  className={
                    selectedBadge === 15 || pathname === '/trips/autoplannertrips/tours'
                      ? 'activeIcon icon'
                      : 'icon'
                  }
                  icon='bx:trip'
                />
              </Badge>
            </Tooltip>
          )}
          {(APagent || APsubAgent) && (
            <Tooltip
              leaveDelay={100}
              title='Scheduled'
              placement='right'
              TransitionProps={{ timeout: 300 }}
              TransitionComponent={Zoom}
              arrow
            >
              <Badge
                className={
                  selectedBadge === 16 ||
                  pathname === '/trips/autoplannertrips/scheduled-tour'
                    ? 'active'
                    : 'nonActive'
                }
                onClick={() => handleBadgeClick(16)}
              >
                <Icon
                  className={
                    selectedBadge === 16 ||
                    pathname === '/trips/autoplannertrips/scheduled-tour'
                      ? 'activeIcon icon'
                      : 'icon'
                  }
                  icon='icon-park-outline:table-report'
                />
              </Badge>
            </Tooltip>
          )}
          {APagent && (
            <Tooltip
              leaveDelay={100}
              title='Company User'
              placement='right'
              TransitionProps={{ timeout: 300 }}
              TransitionComponent={Zoom}
              arrow
            >
              <Badge
                className={
                  selectedBadge === 14 || pathname === '/configuration/agents'
                    ? 'active'
                    : 'nonActive'
                }
                onClick={() => handleBadgeClick(14)}
              >
                <Icon
                  className={
                    selectedBadge === 14 || pathname === '/configuration/agents'
                      ? 'activeIcon icon'
                      : 'icon'
                  }
                  icon='fluent:person-key-32-regular'
                />
              </Badge>
            </Tooltip>
          )}

          {!toDisplay?.some((item: boolean) => item) && (
            <Tooltip
              leaveDelay={100}
              title='Geofence'
              placement='right'
              TransitionProps={{ timeout: 300 }}
              TransitionComponent={Zoom}
              arrow
            >
              <Badge
                className={
                  selectedBadge === 13 || pathname === '/geofencemapping'
                    ? 'active'
                    : 'nonActive'
                }
                onClick={() => handleBadgeClick(13)}
              >
                <Icon
                  className={
                    selectedBadge === 13 || pathname === '/geofencemapping'
                      ? 'activeIcon icon'
                      : 'icon'
                  }
                  icon='wpf:geofence'
                />
              </Badge>
            </Tooltip>
          )}
          {!APagent &&
          !APsubAgent &&
          (category === 'OPERATION_USER'
            ? roleModuleTypes?.some((item: any) => roleModules?.includes(item))
            : true) ? (
            <Tooltip
              leaveDelay={100}
              title='Management'
              placement='right'
              TransitionProps={{ timeout: 300 }}
              TransitionComponent={Zoom}
              arrow
            >
              <Badge
                className={
                  selectedBadge === 8 || pathname === '/configuration'
                    ? 'active'
                    : 'nonActive'
                }
                onClick={() => handleBadgeClick(8)}
              >
                <Icon
                  className={
                    selectedBadge === 8 || pathname === '/configuration'
                      ? 'activeIcon icon'
                      : 'icon'
                  }
                  icon='icon-park-outline:setting-config'
                />
              </Badge>
            </Tooltip>
          ) : (
            ''
          )}
          {(APsuperAdmin ||
            APoperator ||
            yaanTRAC ||
            (category === 'OPERATION_USER' && roleModules?.includes('reports'))) && (
            <Tooltip
              leaveDelay={100}
              title='Reports'
              placement='right'
              TransitionProps={{ timeout: 300 }}
              TransitionComponent={Zoom}
              arrow
            >
              <Badge
                className={
                  selectedBadge === 5 || pathname === '/management'
                    ? 'active'
                    : 'nonActive'
                }
                onClick={() => handleBadgeClick(5)}
              >
                <Icon
                  style={{ transform: 'rotate(45deg)' }}
                  className={
                    selectedBadge === 5 || pathname === '/management'
                      ? 'activeIcon icon'
                      : 'icon'
                  }
                  icon='ci:main-component'
                />
              </Badge>
            </Tooltip>
          )}
          {!APagent &&
          !APsubAgent &&
          !yaanTRAC &&
          !deliveryTracking &&
          category !== 'OPERATION_USER' ? (
            <Tooltip
              leaveDelay={100}
              title={'User Management'}
              placement='right'
              TransitionProps={{ timeout: 300 }}
              TransitionComponent={Zoom}
              arrow
            >
              <Badge
                className={
                  selectedBadge === 19 || pathname === '/users' ? 'active' : 'nonActive'
                }
                onClick={() => handleBadgeClick(19)}
              >
                <Icon
                  className={
                    selectedBadge === 19 || pathname === '/users'
                      ? 'activeIcon icon'
                      : 'icon'
                  }
                  icon='mdi:account-group'
                />
              </Badge>
            </Tooltip>
          ) : (
            ''
          )}

          {/* <Tooltip leaveDelay={100}
            title='Dispatch'
            placement='right'
            TransitionProps={{ timeout: 300 }}
            TransitionComponent={Zoom}
            arrow
          >
            <Badge
              className={
                selectedBadge === 11 || pathname === '/dispatch-management'
                  ? 'active'
                  : 'nonActive'
              }
              onClick={() => handleBadgeClick(11)}
            >
              <Icon
                style={{ transform: 'rotate(45deg)' }}
                className={
                  selectedBadge === 11 || pathname === '/dispatch-management'
                    ? 'activeIcon icon'
                    : 'icon'
                }
                icon='solar:delivery-bold'
              />
            </Badge>
          </Tooltip> */}

          {/* <Tooltip leaveDelay={100}
            title='Delivery tracking'
            placement='right'
            TransitionProps={{ timeout: 300 }}
            TransitionComponent={Zoom}
            arrow
          >
            <Badge
              className={
                selectedBadge === 12 || pathname === '/deliverytracking'
                  ? 'active'
                  : 'nonActive'
              }
              onClick={() => handleBadgeClick(12)}
            >
              <Icon
                className={
                  selectedBadge === 12 || pathname === '/deliverytracking'
                    ? 'activeIcon icon'
                    : 'icon'
                }
                icon='tabler:truck-delivery'
              />
            </Badge>
          </Tooltip> */}
        </Box>
        <Box sx={{ flexGrow: 0, textAlign: 'center' }}>
          {yaanTRAC && (
            <Tooltip
              leaveDelay={100}
              title='Notifications'
              placement='right'
              TransitionProps={{ timeout: 300 }}
              TransitionComponent={Zoom}
              arrow
            >
              <IconButton
                className='notification-icon'
                onClick={handleOpenNotification}
                sx={{ p: 0 }}
              >
                {pathname === '/historynotifications' ? (
                  <Icon className='active-icon' icon='ic:baseline-notifications' />
                ) : (
                  <Icon icon='ic:outline-notifications' />
                )}
              </IconButton>
            </Tooltip>
          )}

          <Tooltip
            leaveDelay={100}
            title='Settings'
            placement='right'
            TransitionProps={{ timeout: 300 }}
            TransitionComponent={Zoom}
            arrow
          >
            <IconButton
              onClick={OpenMyProfile}
              sx={{ p: 0, width: '40px', height: '40px' }}
            >
              <Icon className='personIcon' icon='mdi:person-circle-outline' />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
      {isOpen === 'myprofile' && <MyProfile isOpen={isOpen} handleClose={handleClose} />}
    </Box>
  );
}

export default SideNavbar;
